import { create } from "zustand";

export interface Label {
  id: string;
  name: string;
  color: string;
}

interface LabelState {
  labels: Label[];
  activeLabelId: string | null;
  isLoading: boolean;

  setLabels: (labels: Label[]) => void;
  setActiveLabel: (id: string | null) => void;
  addLabel: (label: Label) => void;
  removeLabel: (id: string) => void;
  updateLabel: (id: string, updates: Partial<Label>) => void;
  setLoading: (loading: boolean) => void;
  reset: () => void;
}

export const useLabelStore = create<LabelState>()((set) => ({
  labels: [],
  activeLabelId: null,
  isLoading: false,

  setLabels: (labels) => set({ labels }),
  setActiveLabel: (activeLabelId) => set({ activeLabelId }),

  addLabel: (label) =>
    set((state) => ({
      labels: [...state.labels, label],
    })),

  removeLabel: (id) =>
    set((state) => ({
      labels: state.labels.filter((l) => l.id !== id),
      activeLabelId: state.activeLabelId === id ? null : state.activeLabelId,
    })),

  updateLabel: (id, updates) =>
    set((state) => ({
      labels: state.labels.map((l) =>
        l.id === id ? { ...l, ...updates } : l,
      ),
    })),

  setLoading: (isLoading) => set({ isLoading }),

  reset: () =>
    set({
      labels: [],
      activeLabelId: null,
      isLoading: false,
    }),
}));
